import '../../ErrorDisplay.css';var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import * as React from "react";
import * as _ from "lodash";
import "../Panel/index.js";
import AssetService from "@ane/core/lib/services/AssetService";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { FieldGroup } from "@ane/ui-components/lib/components/FieldGroup";
import { ErrorDisplayButtons } from "./ErrorDisplayButtons.js";
import Logger from "@ane/core/lib/services/logging/Logger";
import { Accordion } from "@ane/ui-components/lib/components/Accordion";
import { mergeStyles } from "@ane/ui-components/lib/Styling";
import { Panel } from "../Panel/Panel.js";
const ErrorDisplay$1 = "";
class ErrorDisplay extends React.Component {
  componentDidMount() {
    const { message, notificationSource, properties } = this.props;
    const customProps = __spreadValues({
      message,
      notificationSource
    }, properties);
    if (!!(properties == null ? void 0 : properties.isWorkspaceMigration)) {
      Logger.trackMetric({
        name: "MigrationErrorDisplay",
        average: 1,
        properties: customProps
      });
    } else {
      Logger.trackMetric({
        name: "RedBannerError",
        average: 1,
        properties: customProps
      });
    }
  }
  render() {
    const _a = this.props, { message } = _a, rest = __objRest(_a, ["message"]);
    const description = JSON.stringify(
      __spreadValues({
        ExpUIMetadata: {
          Url: window.location.href,
          IsLocal: EnvironmentService.isLocal,
          IsDebug: EnvironmentService.isDebug,
          IsPreRelease: AssetService.isPreReleaseVersion,
          Version: AssetService.getDisplayVersion()
        }
      }, rest),
      null,
      2
    );
    const { properties = {}, correlationId } = rest;
    return /* @__PURE__ */ jsx("div", { className: "error-display", children: /* @__PURE__ */ jsx(FieldGroup, { children: !!(properties == null ? void 0 : properties.isWorkspaceMigration) ? /* @__PURE__ */ jsx(Fragment, { children: message }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Accordion, { ariaLabel: message, header: message, children: this.toDetails("Details", rest) }),
      !(properties == null ? void 0 : properties.isWorkspaceMigration) && /* @__PURE__ */ jsx(
        ErrorDisplayButtons,
        {
          message,
          description,
          clientRequestId: correlationId != null ? correlationId : properties == null ? void 0 : properties.correlationId
        }
      )
    ] }) }) });
  }
  toDetails(title, object, children = null) {
    const _a = object || {}, { isWorkspaceMigration } = _a, details = __objRest(_a, ["isWorkspaceMigration"]);
    const keyValues = _.toPairs(details);
    if (typeof object === "object") {
      return /* @__PURE__ */ jsxs(Panel, { title, children: [
        keyValues.map((k) => {
          const key = k[0];
          const value = k[1];
          const isReurssive = typeof value === "object";
          if (isReurssive) {
            return /* @__PURE__ */ jsx(Accordion, { ariaLabel: key, header: key, children: this.toDetails("", value) }, key);
          } else if (value === void 0 || typeof value === "function") {
            return /* @__PURE__ */ jsx("div", {}, key);
          } else {
            return /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("label", { className: mergeStyles("ane-error-display-details-lable", { color: "#000000" }), children: key }),
              /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("pre", { children: `${value}` }) })
            ] }, key);
          }
        }),
        children
      ] });
    } else {
      return /* @__PURE__ */ jsx("pre", { children: `${object}` });
    }
  }
}
export {
  ErrorDisplay
};
//# sourceMappingURL=ErrorDisplay.js.map
